<template>
    <div class="msg">
        <h1>Page Not Found</h1>

    </div>
</template>

<script>
export default {
    name: "NotFound"
}
</script>

<style lang="scss" scoped>
@import "@/assets/css/global.scss";

.theme-dark.ar {
    .msg {
        display: flex;
        justify-content: center;
        align-items: center;
        height: 800px;

        h1 {
            color: #fff;
            font-size: 100px;
        }
    }
}
.theme-medium.ar {
    .msg {
        display: flex;
        justify-content: center;
        align-items: center;
        height: 800px;

        h1 {
            color: $v3-medium-primarytext;
            font-size: 100px;
        }
    }
}
.theme-light.ar {
    .msg {
        display: flex;
        justify-content: center;
        align-items: center;
        height: 800px;

        h1 {
            color: #000;
            font-size: 100px;
        }
    }
}


.theme-dark.en {
    .msg {
        display: flex;
        justify-content: center;
        align-items: center;
        height: 800px;

        h1 {
            color: #fff;
            font-size: 100px;
        }
    }
}
.theme-medium.en {
    .msg {
        display: flex;
        justify-content: center;
        align-items: center;
        height: 800px;

        h1 {
            color: $v3-medium-primarytext;
            font-size: 100px;
        }
    }
}
.theme-light.en {
    .msg {
        display: flex;
        justify-content: center;
        align-items: center;
        height: 800px;

        h1 {
            color: #000;
            font-size: 100px;
        }
    }
}



</style>